import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ConfirmationService, Message, MessageService } from "primeng/api";
import { concatMap, tap } from "rxjs/operators";
import { AuthService } from "src/app/core/authentication/auth.service";
import { DespositosService } from "src/app/core/services/depositos/despositos.service";
import { ExcelService } from "src/app/core/services/documentos/excel.service";
import { FileService } from "src/app/core/services/documentos/file.service";
import { SolcitudesService } from "src/app/core/services/solicitudes/solcitudes.service";
import { SolicudesAsignadasService } from "src/app/core/services/solicitudesAsignadas/solicudes-asignadas.service";
import { UserService } from "src/app/core/services/user/user.service";
import { PostSolicitud } from "src/app/shared/models/sst/postSolicitud";
import {
  Destino,
  Envio,
  Origen,
  solicitudes,
  User,
} from "src/app/shared/models/sst/solicitudes";

@Component({
  selector: "app-reporte-sst",
  templateUrl: "./reporte-sst.component.html",
  styleUrls: ["./reporte-sst.component.scss"],
})
export class ReporteSstComponent implements OnInit {
  programadores: User[] = [];
  proveedores: User[] = [];
  statuses: any[];
  ordenSST: any[];

  solicitudes: PostSolicitud[] = [];
  querySolicitud: any[] = [];

  spinner = true;

  rol: string;

  mensajeVacio: Message[];

  url: string = "";

  origenes: Origen[] = [];
  destinos: Destino[] = [];

  roles: string[] = [];

  constructor(
    private authService: AuthService,
    private userService: UserService,
    private messageService: MessageService,
    private solicitudesServices: SolcitudesService,
    private router: Router,
    private excelService: ExcelService,
    private depositosService: DespositosService
  ) {
  }

  ngOnInit(): void {
    this.url = this.router.url;
    if (this.url == "/reportes/SST/pendientes") {
      this.querySolicitud.push({
        col: "statuses",
        value: "PENDING",
      });
    }
    this.statuses = [
      { label: "Pendiente", value: "PENDING" },
      { label: "Asignada", value: "ASSIGNED" },
      { label: "Rechazada", value: "REJECTED" },
      { label: "Cancelada", value: "CANCELLED" },
      { label: "Eliminada", value: "DELETED" },
      { label: "Finalizada", value: "FINISHED" },
      { label: "INFORMADA", value: "INFORMED" },
    ];

    this.ordenSST = [
      { label: "Por Destino", value: "DESTINATION" },
      { label: "Por Origen", value: "ORIGIN" },
      { label: "Por Fecha", value: "DATE" },
      { label: "Por Número SST", value: "ID" },
    ];

    this.getData().subscribe({
      complete: () => {
        this.spinner = false;
      }
    })
  }

  getData() {
    return this.userService.getByRol("PROVEEDOR").pipe(tap({
      next: (data) => {
        data.forEach((e) => {
          if (e.azure) {
            this.proveedores.push({ name: e.username, code: e.id });
          } else {
            this.proveedores.push({ name: e.companyName, code: e.id });
          }
        });
      }, error: (error) => {
        this.messageService.add({
          key: "msg",
          severity: "error",
          summary: "Error",
          detail: error.error ? error.error.message : "Ups! ocurrio un error",
        });
      }
    }),
      concatMap(() => this.getProgramadores()),
      concatMap(() => this.getInternos()),
      concatMap(() => this.getDestinos()),
      concatMap(() => this.getOrigenes()),
      concatMap(() => this.getUserActual()),
      concatMap(() => this.getListSolicitudes()),
    )
  }

  getOrigenes() {
    return this.depositosService.getOrigenes().pipe(
      tap({
        next: (res) => {
          res.list.forEach((d) => {
            this.origenes.push({ description: d.name, id: d.id });
          });

          this.origenes.push({ description: "Otro", id: 0 });
        },
      })
    );
  }

  getDestinos() {
    return this.depositosService.getDestinos().pipe(
      tap({
        next: (res) => {
          res.list.forEach((d) => {
            this.destinos.push({ description: d.name, id: d.id });
          });

          this.destinos.push({ description: "Otro", id: 0 });
        },
      })
    );
  }

  getProgramadores() {
    return this.userService.getByRol("PROGRAMADOR").pipe(tap({
      next: (data) => {
        data.forEach((e) => {
          if (e.azure) {
            this.programadores.push({ name: e.username, code: e.id });
          } else {
            this.programadores.push({ name: e.companyName, code: e.id });
          }
        });
      }, error: (error) => {
        this.messageService.add({
          key: "msg",
          severity: "error",
          summary: "Error",
          detail: error.error ? error.error.message : "Ups! ocurrio un error",
        });
      }
    })
    )
  }

  getInternos() {
    return this.userService.getByRol("INTERNAL").pipe(tap({
      next: (data) => {
        data.forEach((e) => {
          if (e.azure) {
            this.proveedores.push({ name: e.username, code: e.id });
          } else {
            this.proveedores.push({ name: e.companyName, code: e.id });
          }
        });
      }, error: (error) => {
        this.messageService.add({
          key: "msg",
          severity: "error",
          summary: "Error",
          detail: error.error ? error.error.message : "Ups! ocurrio un error",
        });
      }
    })
    )
  }

  getUserActual() {
    return this.authService.actual().pipe(
      tap({
        next: (data) => {
          this.roles = data.rolenames
        },
        error: (error) => {
          this.messageService.add({
            key: "msg",
            severity: "error",
            summary: "Error",
            detail: error.error ? error.error.message : "Ups! ocurrio un error",
          });
        }
      })
    )
  }

  getListSolicitudes() {
    return this.solicitudesServices
      .filterReporte(this.querySolicitud, this.pageSolicitudes, this.sizeSolicitudes)
      .pipe(
        tap({
          next: (data) => {
            this.solicitudes = data.list;
            this.totalRecordosSolicitudes = data.totalElements;
          },
          error: (error) => {
            this.messageService.add({
              key: "msg",
              severity: "error",
              summary: "Error",
              detail: error.error ? error.error.message : "Ups! ocurrio un error",
            });
          },
          complete: () => {
          }
        })
      )
  }

  fechaSolicituAsignada = "";
  ordenSolicitudAsignada = "";
  transportistaSolicitudAsignada = "";
  estadoSolicitudAsignada = "";

  fechaSolicitud = "";
  ordenSolicitud = "";
  programadorSolicitud = "";
  estadoSolicitud = "";
  destino = "";
  origen = "";
  esAe = "";
  purchaseOrderNumber = "";
  requestId = "";
  proveedorSolicitud = "";

  minDateValue = new Date();

  startDateSolicitud = "";
  endDateSolicitud = "";


  filtrosSolicitud() {
    this.querySolicitud = [];
    // if (this.fechaSolicitud) {
    //   this.querySolicitud.push({
    //     col: "requirementDate",
    //     value: this.fechaSolicitud,
    //   });
    // }

    if (this.url == "/reportes/SST/pendientes") {
      this.querySolicitud.push({
        col: "statuses",
        value: "PENDING",
      });
    }

    if (this.startDateSolicitud) {
      this.minDateValue = new Date(this.startDateSolicitud);
    }

    if (this.startDateSolicitud && this.endDateSolicitud) {
      this.querySolicitud.push({
        col: "startDate",
        value: this.startDateSolicitud,
      });
      this.querySolicitud.push({
        col: "endDate",
        value: this.endDateSolicitud,
      });
    }

    if (this.ordenSolicitud) {
      this.querySolicitud.push({
        col: "sort",
        value: this.ordenSolicitud,
      });
    }
    if (this.programadorSolicitud) {
      this.querySolicitud.push({
        col: "programmerId",
        value: this.programadorSolicitud,
      });
    }
    if (this.estadoSolicitud) {
      this.querySolicitud.push({
        col: "statuses",
        value: this.estadoSolicitud,
      });
    }
    if (this.destino) {
      this.querySolicitud.push({
        col: "destinationId",
        value: this.destino,
      });
    }
    if (this.origen) {
      this.querySolicitud.push({
        col: "originId",
        value: this.origen,
      });
    }
    if (this.requestId) {
      this.querySolicitud.push({
        col: "requestId",
        value: this.requestId,
      });
    }
    if (this.esAe) {
      this.querySolicitud.push({
        col: "esAe",
        value: this.esAe,
      });
    }
    if (this.purchaseOrderNumber) {
      this.querySolicitud.push({
        col: "purchaseOrderNumber",
        value: this.purchaseOrderNumber,
      });
    }
    if (this.proveedorSolicitud) {
      this.querySolicitud.push({
        col: "supplierId",
        value: this.proveedorSolicitud,
      });
    }
    if (this.querySolicitud.length > 0) {
      this.spinner = true;
    }
    this.getListSolicitudes().subscribe({
      complete: () => {
        this.spinner = false;
      }
    })
  }


  descargarReporteSst() {
    this.excelService.descargarSst(this.querySolicitud).subscribe(
      (data) => {
        var downloadURL = URL.createObjectURL(data);
        var link = document.createElement("a");
        link.href = downloadURL;
        link.download = `reporte-SST.xlsx`;
        link.click();
      },
      (error) => {
        this.messageService.add({
          key: "msg",
          severity: "error",
          summary: "Error",
          detail: error.error ? error.error.message : "Ups! ocurrio un error",
        });
      }
    );
  }

  //paginado --INICIO
  totalRecordosSolicitudes = 0;
  pageSolicitudes = 1;
  sizeSolicitudes = 10;

  paginateSolicitudes(event) {
    this.pageSolicitudes = event.page + 1;
    this.sizeSolicitudes = event.rows;
    this.getListSolicitudes().subscribe();
  }

  columnasPending() {
    if (this.url == "/reportes/SST/pendientes") {
      return "col-12"
    }
    return "col-6"
  }

  hasRole(role: string) {
    return this.roles.indexOf(role) !== -1;
  }
}
